import { render, staticRenderFns } from "./cModaldiagnostico.vue?vue&type=template&id=241390f0"
import script from "./cModaldiagnostico.vue?vue&type=script&lang=js"
export * from "./cModaldiagnostico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports